import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import PostApi from '../../api/PostApi';
import { getPostBaseUrl } from '../../constant/PostClass';

const removeNicknm = title => {
    const tList = title.split('/++writer-seperator++/');
    if (tList.length === 1) return title;
    return tList[tList.length - 1];
}

const RecentContent = () => {
    const navigate = useNavigate();
    const [curTab, setCurTab] = useState('post');
    const [recentContent, setRecentContent] = useState([]);

    const handleAClick = async ({post_id, post_type}) => {
        const baseUrl = getPostBaseUrl(post_type);
        navigate(`${baseUrl}/post/detail/${post_id}?postType=${post_type}`);
        window.scrollTo({ top: 0, behavior: 'smooth' });  
    }

    useEffect(() => {
        PostApi.getRecentContents().then(res => {
            if (res.code === 'fail') return;
            setRecentContent(res.data);
        });
    }, []); 

    return (
        <div className="bbs-widget">
            <div className="bbs-widget-head">
                <ul className="bbs-widget-tablist">
                    <li className={curTab === 'post' ? 'active' : ''} onClick={() => setCurTab('post')}>새글</li>
                    <li className={curTab === 'comment' ? 'active' : ''} onClick={() => setCurTab('comment')}>새댓글</li>
                </ul>
                {/* <a title="더보기">
                    <i className="icon icon-arrow-right-bold"></i>
                </a> */}
            </div>
            <div className="bbs-widget-tabpanel">
                <ul>
                    {recentContent.filter(({type}) => type === curTab).map(c =>
                        <li><a onClick={() => handleAClick(c)}>{removeNicknm(c.title)}</a></li>
                     )}
                </ul>
            </div>
        </div>
    )

}

export default RecentContent;